/* modal-loading-error.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./modal-loading-error.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { useDatasourceAnalyticsEvents } from '../../../analytics';
import { SpotErrorSearch } from '../../../common/ui/spot/error-state/search';
import { LoadingErrorSVGOld } from './loading-error-svg-old';
import { loadingErrorMessages } from './messages';
var styles = {
  errorContainerStyles: "_zulp1ejb _4cvr1h6o _6a6z1h6o _1wpz1h6o _10fp1h6o _1e0c11p5",
  errorMessageContainerStyles: "_zulpu2gc _4cvr1h6o _6a6z1h6o _1e0c11p5"
};
export var ModalLoadingError = function ModalLoadingError(_ref) {
  var _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? /*#__PURE__*/React.createElement(FormattedMessage, loadingErrorMessages.checkConnection) : _ref$errorMessage;
  var _useDatasourceAnalyti = useDatasourceAnalyticsEvents(),
    fireEvent = _useDatasourceAnalyti.fireEvent;
  useEffect(function () {
    fireEvent('ui.error.shown', {
      reason: 'network'
    });
  }, [fireEvent]);
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.errorContainerStyles,
    testId: "datasource-modal--loading-error"
  }, fg('bandicoots-update-sllv-icons') ? /*#__PURE__*/React.createElement(SpotErrorSearch, {
    size: 'xlarge',
    alt: ""
  }) : /*#__PURE__*/React.createElement(LoadingErrorSVGOld, null), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.errorMessageContainerStyles
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, /*#__PURE__*/React.createElement(FormattedMessage, loadingErrorMessages.unableToLoadResults)), /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, errorMessage)));
};